import React from 'react';
import { readSrmPlanDocument } from '../../../functions/src/common/srmPlanDocument';
import { createSafeMarkdown } from '../../utils/safeMarkdown';
import './srmPlanDocument.css';

const md = createSafeMarkdown({ html: true, linkify: true, typographer: true });
const renderer = (md as typeof md & { renderer: { rules: Record<string, () => string> } }).renderer;
renderer.rules.table_open = () => '<div class="srm-plan-table" tabindex="0" role="region" aria-label="Plan table"><table>\n';
renderer.rules.table_close = () => '</table></div>\n';

export default function SrmPlanDocumentDisplay({ result, title }: { result: unknown; title: string }) {
    const document = readSrmPlanDocument(result);
    const heading = document.markdown.match(/^# ([^\n]+)\n?/);
    const body = (heading ? document.markdown.slice(heading[0].length) : document.markdown)
        .replace(/^(\s*[-*+]\s+)\[([ xX])\]\s/gm, (_match, prefix: string, checked: string) => `${prefix}<span class="srm-plan-check" aria-hidden="true">${checked.trim() ? '☑' : '☐'}</span> `);
    return <article className="srm-plan-document" aria-label={title}>
        <header className="srm-plan-header"><p className="srm-plan-label">SRM facility plan</p><h1>{heading?.[1] || title}</h1></header>
        {document.gaps.length > 0 && <aside role="status" className="srm-plan-notice">{document.gaps.map(gap => <p key={gap}>{gap}</p>)}</aside>}
        {body && <div className="srm-plan-body" dangerouslySetInnerHTML={{ __html: md.render(body) }} />}
    </article>;
}
